
import { Graphics } from "common/enums"
import { isPointAt, isContained } from 'util/math'
import { fromPoints, fromLine } from 'core/bbox.js'
/**
 * 白板数据
 */
class PageStore {
  constructor(data) {
    /**
     * 全量数据存储
     * boardData : {
     *     seq_id: '' // 暂时不清楚作用
     *     board_name: 'xxx',
     *     board_type: 'xxx',
     *     "width":1280,
     *     "height":720,
     *     "page":10,
     *     "current_pid":2,
     *     "file_path":,
     *     "convert_file_path",
     *     paintMap:   // map key: 页码 value: [obj]  图元对象
     * }
     */
    this.boardData = { paintMap: new Map() }
    // 白板编辑状态
    this.editConfig = {
      id: 1, 
      status: false
    }
    this.shape = Graphics.CURVE
    this.color  = 4278255442
    this.brush_size = 4
    // 撤销栈
    this.revokeStack = []
    // 恢复栈
    this.restoreStack = []
    // 图元增量
    this.graphIdSeed = 0

    this._init(data)
    return this
  }

  /**
   * 初始化
   * @param {*} data 
   */
  _init(data) {
    // 第一个元素是白板属性数据
    let pageData = data.slice(0, 1)

    // 后面的元素是白板图元数据
    let paintObjs = data.slice(1)

    // 保存白板属性数据
    this.boardData = Object.assign(this.boardData, pageData[0].board)

    // 解析所有白板图元
    if (paintObjs.length > 0) {
      paintObjs.map((item) => {
        let items = this.boardData.paintMap.get(item[item.type].pid)
        if (!items) {
          this.boardData.paintMap.set(item[item.type].pid, [item])
          return
        }
        items.push(item)
        this.boardData.paintMap.set(item[item.type].pid, items)
      })
    } else {
      this.boardData.paintMap.set(pageData[0].board.current_pid, [])
    }
  }
  clearPaints () {
    this.boardData.paintMap = new Map()
    this.boardData.paintMap.set(this.getCurPage(), [])
  }

  /**
   * 获取当前显示第几页
   */
  getCurPage () {
    return this.boardData.current_pid
  }

  /**
   * 获取白板总页数
   */
  getPageCount() {
    return this.boardData.page;
  }

  /**
   * TODO：获取白板文档背景图片
   */
  getFilePath() {
    return this.boardData.convert_file_path;
  }

  /**
   * 获取白板图片URL前半部分：convert_file_path/xxx.jgp
   */
  getConvertFilePath() {
    return this.boardData.convert_file_path;
  }

  /**
   * 设置当前显示的页码
   * @param {*} pid 
   */
  setCurPage (pid) {
    this.boardData.current_pid = pid
  }

  /**
   * 获取白板名称
   */
  getBoardName() {
    if (Object.prototype.hasOwnProperty.call(this.boardData, 'user_data') && this.boardData.user_data) {
      let user_data = JSON.parse(this.boardData.user_data)
      let ex_name = user_data.ex_name
      return ex_name ? `${this.boardData.board_name}.${ex_name}`: this.boardData.board_name
    } else {
      return this.boardData.board_name
    }
  }

  /**
   * 删除白板页
   * @param {*} item 
   */
  deletePage (item) {
    let items = this.boardData.paintMap.get(item[item.type].pid)
    if (items) {
      this.boardData.paintMap.set(item[item.type].pid, [])
    }
  }

  /**
   * 获取白板页上的所有图元
   * @param {*} pid 
   */
  findPagePaints(pid) {
    if (!this.boardData.paintMap.get(pid)) {
      this.boardData.paintMap.set(pid, [])
    }
    return this.boardData.paintMap.get(pid)
  }

  /**
   * 根据gid查找图元数据
   * @param {*} pageData 
   * @param {*} gid 
   */
  findPaintByGid (pageData, gid) {
    for (var i = 0; i < pageData.length; i++) {
      let data = pageData[i]
      // 判断ObjId是否相等
      if (data[data.type].gid === gid) {
        // 替换全量对应ID的Obj
        return data
      }
    }
    return null
  }

  /**
   * 删除图元
   * @param {*} pageData 页图元数据组
   * @param {*} paintObj
   */
  deletePaintObj(pageData, gid) {
    for (var i = 0; i < pageData.length; i++) {
      let data = pageData[i]
      // 判断ObjId是否相等
      if (data[data.type].gid === gid) {
        // 替换全量对应ID的Obj
        pageData.splice(i, 1)
        console.log('===>', pageData)
        break
      }
    }
  }

  /**
   * 添加图元
   * @param {*} pageData 
   * @param {*} paintObj 
   */
  addPaintObj (pageData, paintObj) {
    pageData.push(paintObj)
  }

  /**
   * 
   * @param {*} pageData 
   * @param {*} paintObj 
   */
  amendPaintObj(pageData, paintObj) {
    for (var i = 0; i < pageData.length; i++) {
      let data = pageData[i]
      // 判断ObjId是否相等
      if (data[data.type].gid === paintObj[paintObj.type].gid) {
        // 替换全量对应ID的Obj
        if (data.type === Graphics.CURVE) {
          data[data.type].points.push(...paintObj[paintObj.type].points)
        } else {
          pageData.splice(i, 1, paintObj)
        }
        break
      }
    }
  }
  /**
   * 替换图元
   * @param {*} pageData 
   * @param {*} gid 
   * @param {*} paintData 
   */
  repalcePaintObj (pageData, gid, paintData) {
    for (var i = 0; i < pageData.length; i++) {
      let data = pageData[i]
      if (data[data.type].gid === gid) {
        data[data.type] = paintData
        break
      }
    }
  }
  /**
   * 移动图元
   * @param {*} pageData 
   * @param {*} gid 
   * @param {*} paintObj 
   */
  movePaintObj(pageData, gid, paintObj) {
    for (var i = 0; i < pageData.length; i++) {
      let data = pageData[i]
      // 判断ObjId是否相等
      if (data[data.type].gid === gid) {
        // 替换全量对应ID的Obj
        if (data.type === Graphics.CURVE) {
          data[data.type].points = data[data.type].points.map((item) => {
            return (item = [item[0] + paintObj.ox, item[1] + paintObj.oy])
          })
        } else if (data.type === Graphics.TEXT) {
          data[data.type].left += paintObj.ox
          data[data.type].top += paintObj.oy
        } else {
          if (Object.prototype.hasOwnProperty.call(data[data.type], 'left')) {
            data[data.type].left += paintObj.ox
            data[data.type].bottom += paintObj.oy
            data[data.type].right += paintObj.ox
            data[data.type].top += paintObj.oy
          } else {
            data[data.type].x1 += paintObj.ox
            data[data.type].y1 += paintObj.oy
            data[data.type].x2 += paintObj.ox
            data[data.type].y2 += paintObj.oy
          }
        }
        break
      }
    }
  }
  deletePaintObj(pageData, gid) {
    for (var i = 0; i < pageData.length; i++) {
      let data = pageData[i]
      // 判断ObjId是否相等
      if (data[data.type].gid === gid) {
        try {
          return pageData.splice(i, 1)[0]
        } catch (er) {
          return null
        }
        
      }
    }
    return null
  }
  findPaintsByPoint (pageData, target) {
    let flag = false
    for (var i = 0; i < pageData.length; i++) {
      let data = pageData[i]
      if (data.type === Graphics.CURVE) {
        let points = data[data.type].points
        for(let j = 0; j < points.length - 1; j++) {
          let point0 = points[j]
          let point1 = points[j + 1]
          flag = isPointAt(target, {x: point0[0], y: point0[1]}, {x: point1[0], y: point1[1]})
          if (flag) break;
        }
      } else if (data.type === Graphics.LINE) {
        let points = data[data.type]
        flag = isPointAt(target, {x: points.x1, y: points.y1}, {x: points.x2, y: points.y2})
      }
      if (flag) return data
    }
    return null
  }
 
  containPaintObj (rect) {
    let pageData = this.findPagePaints(this.boardData.current_pid)
    let paints = []
    pageData.map((data) => {
      // 替换全量对应ID的Obj
      if (data.type === Graphics.CURVE) {
        let isContain = true
        data[data.type].points.map((item) => {
          let point = {
            x: item[0],
            y: item[1]
          }
          isContain = isContained(point, rect)
        })
        if (isContain) {
          paints.push(data[data.type].gid)
        }
      } else if (data.type === Graphics.TEXT) {
        // data[data.type].left += paintObj.ox
        // data[data.type].top += paintObj.oy
      } else {
        let item = data[data.type]
        if (Object.prototype.hasOwnProperty.call(item, 'left')) {
          item.x1 = item.left
          item.y1 = item.bottom
          item.x2 = item.right
          item.y2 = item.top
        }
        let point1 = {
          x: item.x1,
          y: item.y1
        }
        let point2 = {
          x: item.x2,
          y: item.y2
        }
        let isContain1 = isContained(point1, rect)
        let isContain2 = isContained(point2, rect)
        if (isContain1 && isContain2) {
          paints.push(data[data.type].gid)
        } 
      }
    })
    return paints
  }
  boundingRect (gid) {
    let pageData = this.findPagePaints(this.boardData.current_pid)
    let graph = this.findPaintByGid(pageData, gid)
    let min = []
    let max = []
    if (graph.type === 'curve') {
      fromPoints(graph[graph.type].points, min, max)
    } else {
      let points = graph[graph.type]
      if (Object.prototype.hasOwnProperty.call(points, 'left')) {
        points.x1 = points.left
        points.y1 = points.bottom
        points.x2 = points.right
        points.y2 = points.top
      }
      fromLine(points.x1, points.y1, points.x2, points.y2, min, max)
    }
    return {
      x1: min[0],
      y1: min[1],
      x2: max[0],
      y2: max[1]
    }
  }
  groupBoundingRect (childrens) {
    // let pageData = this.findPagePaints(this.boardData.current_pid)
    let rect = null
    childrens.map((gid) => {
      let childRect = this.boundingRect(gid)
      rect = rect || childRect
      rect.x1 = Math.min(rect.x1, childRect.x1)
      rect.y1 = Math.min(rect.y1, childRect.y1)
      rect.x2 = Math.max(rect.x2, childRect.x2)
      rect.y2 = Math.max(rect.y2, childRect.y2)
    })
    return rect
  }
}

export default PageStore;